import noop from 'lodash/noop';
import { createContext } from 'react';

import { UseFormFieldsModalsStateReturnType } from './useFormFieldsModalsState';

const defaultModalState = {
  isOpen: false,
  close: noop,
  open: noop,
};

export const FieldsListModalsContext =
  createContext<UseFormFieldsModalsStateReturnType>({
    currentlyActiveFormFieldIndex: null,
    setCurrentlyActiveFormFieldIndex: noop,
    fieldDetailsModal: defaultModalState,
  });
